// extracted by mini-css-extract-plugin
export default {"container":"IsNewTemplate_container__JD14L","button":"IsNewTemplate_button__iNcg5","new":"IsNewTemplate_new__dcehu","old":"IsNewTemplate_old__9WjdY"};